import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, Typography } from '@mui/material';
import { Modal } from '../../components';
import ListadoTiposInvitacion from './components/ListadoTiposInvitacion';
import FormTiposInvitacion from './components/FormTiposInvitacion';
import {
  getAllTiposInvitacionAction,
  setActivoTiposInvitacionAction,
} from './TiposInvitacionAction';
import BotonNuevoComponent from '../entidades/components/BotonNuevo';
import { checkModuleAccess } from '../modulos/modules.helpers';

const TiposInvitacionView = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const tiposInvitacionStore = Redux.useSelector(
    (state) => state.tiposInvitacion
  );

  const loginStore = Redux.useSelector((state) => state.login);
  const accessName = 'invitation';
  if (!checkModuleAccess(accessName, loginStore)) {
    window.location.href = '/dashboard';
  }

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonNuevoComponent
          click={async () => {
            await setActivoTiposInvitacionAction(dispatch, null);
            setOpenModalForm(true);
          }}
          azul
          mr={2}
        />
        {tiposInvitacionStore.all.length > 0 && (
          <BotonNuevoComponent
            click={async () => {
              await setActivoTiposInvitacionAction(dispatch, null);
              await getAllTiposInvitacionAction(
                dispatch,
                entidadesStore.activo.id,
                null
              );
            }}
            disabled={tiposInvitacionStore.loadingGetAll}
            white
            text={
              tiposInvitacionStore.loadingGetAll
                ? 'Actualizando...'
                : 'Actualizar'
            }
          />
        )}
      </Grid>
      <Grid item md={12}>
        <ListadoTiposInvitacion
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Grid>
      <Modal
        id="modalFormTiposInvitacion"
        title={`${
          tiposInvitacionStore.activo ? 'Editar' : 'Nuevo'
        } tipo de invitación`}
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        {tiposInvitacionStore.activo && (
          <Typography variant="h6">
            {tiposInvitacionStore.activo.nombres}{' '}
            {tiposInvitacionStore.activo.apellidos}
          </Typography>
        )}
        <FormTiposInvitacion
          activo={tiposInvitacionStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Modal>
    </Grid>
  );
};

export default TiposInvitacionView;
